// v2.30 — « Partager mes tarifs privés » : la grille est générée depuis la matrice tarifaire (jamais fausse),
// copiée ou partagée telle quelle (WhatsApp, Instagram…). Le texte peut être retouché avant l'envoi.
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { X } from 'lucide-react';
import { api } from '../../api';

export default function PrivateCardSheet({ onClose }) {
  const [card, setCard] = useState(null);
  const [text, setText] = useState('');
  useEffect(() => {
    api.get('/pricing/private-card').then(c => { setCard(c); setText(c.text); }).catch(() => toast.error('Tarifs introuvables'));
  }, []);
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success('Tarifs copiés'); } catch { toast.error('Copie impossible'); }
  };
  const share = async () => {
    try { await navigator.share({ text }); } catch { /* annulé */ }
  };
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-end md:items-center justify-center" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="bg-white w-full md:max-w-md rounded-t-3xl md:rounded-2xl shadow-2xl max-h-[92vh] overflow-y-auto" data-testid="private-card-sheet"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <h2 className="font-bold text-lg text-slate-900 font-manrope">Partager mes tarifs privés</h2>
          <button onClick={onClose} aria-label="Fermer" className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100"><X size={16} /></button>
        </div>
        {!card ? <div className="p-6 text-sm text-slate-400">Chargement…</div> : (
          <div className="p-5 space-y-4">
            <div className="rounded-2xl border border-slate-200 overflow-hidden" data-testid="private-card">
              <div className="px-4 py-3 border-b border-slate-100">
                <div className="font-bold text-slate-900">{card.title}</div>
                <div className="text-xs text-slate-500">{card.sub}</div>
              </div>
              <table className="w-full text-sm">
                <thead><tr className="text-xs text-slate-500">
                  <th className="text-left px-4 py-2 font-semibold">1 h</th><th className="text-right px-2 py-2 font-semibold">Seul·e</th><th className="text-right px-4 py-2 font-semibold">À deux</th>
                </tr></thead>
                <tbody>
                  {card.rows.map(r => (
                    <tr key={r.label} className="border-t border-slate-100">
                      <td className="px-4 py-2 text-slate-800">{r.label}</td>
                      <td className="px-2 py-2 text-right font-bold text-slate-900 whitespace-nowrap">{r.solo} CHF</td>
                      <td className="px-4 py-2 text-right font-bold text-slate-900 whitespace-nowrap">{r.duo ? `${r.duo} CHF` : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="px-4 py-2 border-t border-slate-100 text-xs text-slate-500">{card.footer}</div>
            </div>
            <div>
              <div className="text-xs font-bold text-slate-500 mb-1">Texte envoyé (modifiable avant l'envoi)</div>
              <textarea value={text} onChange={e => setText(e.target.value)} rows={7} data-testid="private-card-text"
                className="w-full px-3 py-2 rounded-xl border border-slate-200 bg-slate-50 text-sm" />
              <div className="text-[11px] text-slate-400 mt-1">Les prix viennent de Profil › Matrice tarifaire : change-les là-bas, la grille suit.</div>
            </div>
            <div className="flex gap-2">
              <button onClick={copy} className="flex-1 h-11 rounded-xl bg-slate-100 text-slate-700 font-bold text-sm" data-testid="private-card-copy">Copier</button>
              {typeof navigator !== 'undefined' && navigator.share && (
                <button onClick={share} className="flex-1 h-11 rounded-xl bg-[#26A69A] text-white font-bold text-sm">Partager…</button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
